import { render, staticRenderFns } from "./real-time-answers.vue?vue&type=template&id=70cb533a&scoped=true&"
import script from "./real-time-answers.vue?vue&type=script&lang=js&"
export * from "./real-time-answers.vue?vue&type=script&lang=js&"
import style0 from "./real-time-answers.vue?vue&type=style&index=0&id=70cb533a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cb533a",
  null
  
)

export default component.exports